export default "__VITE_ASSET__CcefmUI7__"